//#region src/events.ts
const HOST_EVENTS = {
	AUTH_CHANGED: "host:auth-changed",
	VIEWPORT_CHANGED: "host:viewport-changed",
	PATH_CHANGED: "host:path-changed",
	INVALIDATE: "host:invalidate",
	WS_PUSH: "host:ws-push"
};
const INVALIDATE_RESOURCE = {
	NOTIFICATIONS: "notifications",
	ACCOUNT_INFO: "account-info",
	BILLING_PAYMENT_CARD: "billing/payment-card"
};
const SUB_EVENTS = {
	MOUNTED: "sub:mounted",
	PATH_CHANGED: "sub:path-changed",
	AUTH_ERROR: "sub:auth-error",
	CONTEXT_INVALIDATED: "sub:account-context-invalidated",
	INVALIDATE: "sub:invalidate",
	PAYMENT_EDIT: "sub:payment-edit"
};
//#endregion
//#region src/capabilities.ts
const HOST_CAPABILITIES = {
	ASSIGN: "assign",
	REPLACE: "replace"
};
const noop = () => {};
const nullSnapshot = () => null;
const warnedFields = /* @__PURE__ */ new Set();
function warnFieldOnce(field) {
	var _process$env;
	if (typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === "production") return;
	if (warnedFields.has(field)) return;
	warnedFields.add(field);
	console.warn(`host-bridge-contract: SubProps.${field} missing or invalid; falling back to noop (host wiring bug or running outside wujie)`);
}
function readSubProps(raw) {
	if (raw === null || raw === void 0 || typeof raw !== "object") return {
		assign: noop,
		replace: noop,
		getInitialState: nullSnapshot
	};
	const obj = raw;
	function pickFn(key, fallback) {
		const fn = obj[key];
		if (typeof fn !== "function") {
			warnFieldOnce(key);
			return fallback;
		}
		return fn;
	}
	return {
		assign: pickFn("assign", noop),
		replace: pickFn("replace", noop),
		getInitialState: pickFn("getInitialState", nullSnapshot)
	};
}
//#endregion
//#region src/envelope.ts
function envelope(kind, payload) {
	return {
		v: 1,
		kind,
		payload
	};
}
function isCompatibleVersion(v) {
	return v === 1;
}
//#endregion
//#region src/bus-helpers.ts
const warned = /* @__PURE__ */ new Set();
function warnOnce(key, msg) {
	var _process$env;
	if (typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === "production") return;
	if (warned.has(key)) return;
	warned.add(key);
	console.warn(msg);
}
function emitMessage(bus, kind, ...args) {
	if (!bus) {
		warnOnce("emit-no-bus", "host-bridge-contract: emitMessage called without bus; running outside wujie host");
		return;
	}
	const payload = args[0];
	bus.$emit(kind, envelope(kind, payload));
}
function onMessage(bus, kind, handler) {
	if (!bus) {
		warnOnce("on-no-bus", "host-bridge-contract: onMessage called without bus; running outside wujie host");
		return () => {};
	}
	const wrapped = (...args) => {
		const msg = args[0];
		if (!isCompatibleVersion(msg === null || msg === void 0 ? void 0 : msg.v)) {
			warnOnce(`v-${kind}`, `host-bridge-contract: dropping ${kind} envelope with unknown v=${String(msg === null || msg === void 0 ? void 0 : msg.v)}`);
			return;
		}
		handler(msg === null || msg === void 0 ? void 0 : msg.payload);
	};
	bus.$on(kind, wrapped);
	return () => bus.$off(kind, wrapped);
}
//#endregion
//#region src/legacy-owned-paths.ts
const LEGACY_OWNED_PATHS = [
	"/clusters",
	"/management",
	"/cloud",
	"/redirect"
];
//#endregion
export { HOST_CAPABILITIES, HOST_EVENTS, INVALIDATE_RESOURCE, LEGACY_OWNED_PATHS, SUB_EVENTS, emitMessage, envelope, isCompatibleVersion, onMessage, readSubProps };
